import axios from 'axios.js'

export const GET_REPORT_RULES = 'GET_REPORT_RULES'
const REPORT_RULE_API_URL = '/api/report_rules'

export const getReportRules = (filter, paginate) => (dispatch) => {
    if(paginate!==null && filter!=null){
        
        axios.post(REPORT_RULE_API_URL,filter, {params:paginate}).then((res) => {
            if(res.data.result_status === 200){
                dispatch({
                    type: GET_REPORT_RULES,
                    payload: res.data.data,
                })
            }else{
                dispatch({
                    type: GET_REPORT_RULES,
                    payload: null,
                })
            }
        })
    }
}






